module.exports = __webpack_public_path__ + "29619be20beba7b5170a4b8f3a7b68a2.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/museo_slab_500-webfont.woff
// module id = qBlM
// module chunks = 0